import { useMutation } from '@tanstack/react-query';
import type { ApiResponse } from '@/lib/api';
import { apiRequest } from '@/lib/api-utils';
import { API_ENDPOINTS } from '@/lib/constants';

export type ImageStyle =
  | 'illustration'
  | 'photorealistic'
  | 'graphic_design'
  | 'cartoon'
  | 'minimalist'
  | 'watercolor';

export interface GeneratePartnerEmailRequest {
  userPrompt: string;
  imageStyle?: ImageStyle;
}

export interface GeneratePartnerEmailResponse {
  html: string;
  css: string;
  compiledHtml: string;
  subject: string;
  previewText: string;
  smsText: string;
}

async function generatePartnerEmail(
  payload: GeneratePartnerEmailRequest,
): Promise<GeneratePartnerEmailResponse> {
  const response = await apiRequest<ApiResponse<GeneratePartnerEmailResponse>>(
    API_ENDPOINTS.PARTNER.AI_AUTOMATION_GENERATE_CONTENT,
    {
      method: 'POST',
      body: JSON.stringify(payload),
    },
  );

  return response.data;
}

export function useGeneratePartnerEmail() {
  return useMutation({
    mutationFn: generatePartnerEmail,
  });
}
